import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-text-block',
  templateUrl: './text-block.component.html',
  styleUrls: ['./text-block.component.scss']
})
export class TextBlockComponent {

  @Output()
  action: EventEmitter<void> = new EventEmitter();

  @Input()
  text: {
    heading: string;
    content: string[];
    action: string;
  }

  doAction() {
    this.action.emit();
  }

}